import { IStateScore } from './score';

export const defaultScore: IStateScore = {
    comboReset: false,
    multiplier: 1,
    score: 0,
    tiers: [10, 50, 200],
    totalScore: 0,
    winTime: -1,
};
